import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DictionaryContractType } from 'src/app/extensions/constants/dictionaryConstants/dictionaryConstants';

@Component({
  selector: 'contracts-card-view',
  templateUrl: './card-view.component.html',
  styleUrls: ['./card-view.component.scss'],
  standalone: false,
})
export class ContractCardViewComponent {
  @Input() contracts: app.models.ContractModel[] = [];
  @Input() props: app.models.DynamicPropsDictionary;
  @Output() viewDetails: EventEmitter<string> = new EventEmitter<string>();
  ContractType = DictionaryContractType;

  constructor() {}

  viewDetailsHandler(id: string) {
    this.viewDetails.emit(id);
  }
}
